/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { booleanAttribute, Component, Input } from '@angular/core';
import { IconComponent, IconVariants } from '../../icon/icon.component';

@Component({
  selector: 'ods-mail-icon',
  imports: [IconComponent],
  host: { class: 'relative inline-block size-fit', 'aria-hidden': 'true' },
  template: `<ods-icon name="mail" [size]="size" [fill]="fill" />
    @if (withBadge) {
      <div
        class="bg-primary absolute top-1/5 left-1/2 size-2/5 translate-x-1/2 -translate-y-1/2 rounded-full"
        data-test-class="mail-icon-badge"
      ></div>
    }`,
})
export class MailIconComponent {
  @Input() size: IconVariants['size'] = 'medium';
  @Input() fill: IconVariants['fill'] = 'text';
  @Input({ transform: booleanAttribute }) withBadge: boolean = false;
}
